import { Component, ojs, app, payload } from "modular-openscriptjs";
import { sendEvent, authenticated, pageInfo, scrollToTop } from "../../helpers";
import AuthenticatedIndex from "./AuthenticatedIndex";
import UnAuthenticatedIndex from "./UnAuthenticatedIndex";
import { PAGES } from "../../declarations";
import { $e } from "../../ojs.events";

const h = app("h");
const broker = app("broker");


ojs(AuthenticatedIndex, UnAuthenticatedIndex);

export default class Index extends Component {

	render(auth, ...args) {
		pageInfo(PAGES.HOME);
		scrollToTop();

		if (auth.value) return this.auth(...args);
		return this.default(...args);
	}

	auth(...args) {
		return h.AuthenticatedIndex(...args);
	}

	default(...args) {
		return h.UnAuthenticatedIndex(...args);
	}

	addToCart(product) {
		broker.broadcast($e.cart.itemSelected, payload({ item: product }));
	}

	editProduct(product) {
		broker.send($e.product.needs.update, payload({ item: product }));
	}

	updateItem(item) {
		broker.send($e.cart.needs.itemUpdateForm, payload({ item }));
	}

	deleteProduct(product) {
		broker.send($e.product.needs.deletion, payload({ id: product.id }));
	}

	copyProduct(product) {
		delete product.id;
		broker.send($e.product.needs.creation, payload({ item: product }));
	}

	shareProduct(product) {
		broker.send(
			$e.product.needs.share,
			payload({ id: product.id, product })
		);
	}

	repeatOrder(orderId) {
		if (!authenticated()) sendEvent($e.user.needs.authentication);

		broker.send($e.order.needs.repeat, payload({ orderId }));
	}
}

ojs(Index);
